var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#/login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('vue-button-spinner', {
    staticStyle: {
      "background-color": "#20a8d8",
      "color": "white"
    },
    attrs: {
      "is-loading": _vm.loading,
      "disabled": _vm.loading,
      "type": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "to": '/resetpassword'
    }
  }, [_vm._v("Forgot password?")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card d-md-down"
  }, [_c('div', {
    staticClass: "card-body text-center text-white bg-primary"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Belum Memiliki User??")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary active mt-3",
    attrs: {
      "to": '/register'
    }
  }, [_vm._v("Register Now!")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Lapor Barang Transit")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    attrs: {
      "to": '/menutransit'
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-truck"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Klik Disini!")])])], 1)])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6aa830","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 170
// module chunks = 0